import { useFormikContext } from "formik";

import { useNavPrompt } from "./hooks/useNavPrompt";

import {
  BlockNavigationAlert,
  type BlockNavigationAlertProps,
} from "./BlockNavigationAlert";

export interface FormikBlockNavigationProps extends Omit<
  BlockNavigationAlertProps,
  "isOpen" | "onClose" | "onSubmit" | "onDiscardChanges"
> {
  /** Force the navigation block regardless of Formik dirty state. */
  isDirty?: boolean;
}

const FormikBlockNavigation = ({
  isDirty = false,
  ...otherProps
}: FormikBlockNavigationProps) => {
  const formikContext = useFormikContext();
  const shouldBlock =
    isDirty || (Boolean(formikContext) && Boolean(formikContext.dirty));

  const { isBlocked, continueNavigation, hidePrompt } = useNavPrompt({
    shouldBlock,
  });

  const handleDiscardChanges = () => {
    if (formikContext) formikContext.resetForm();
    hidePrompt();
    continueNavigation();
  };

  return (
    <BlockNavigationAlert
      isOpen={isBlocked}
      onClose={hidePrompt}
      onDiscardChanges={handleDiscardChanges}
      onSubmit={hidePrompt}
      {...otherProps}
    />
  );
};

FormikBlockNavigation.displayName = "FormikBlockNavigation";

export { FormikBlockNavigation };
export type { BlockNavigationAlertProps };
